module.exports = __webpack_public_path__ + "img/03hylw.db8c4641.svg";